<template>
  <div v-if="isMaxScreen" class="pc_order-steps">
    <div class="step-item">
      <img src="@/assets/PC/img/step1.png" alt="" />
      {{$t('PCOrderStep.index.646xagqwff40')}}
    </div>
    <div class="line"></div>
    <div class="step-item">
      <img src="@/assets/PC/img/step2.png" alt="" />
      {{$t('PCOrderStep.index.646xagqwkuw0')}}
    </div>
    <div class="line"></div>
    <div class="step-item">
      <img src="@/assets/PC/img/step3.png" alt="" />
      {{$t('PCOrderStep.index.646xagqwmao0')}}
    </div>
    <div class="line"></div>
    <div class="step-item">
      <img src="@/assets/PC/img/step4.png" alt="" />
      {{$t('PCOrderStep.index.646xagqwmlc0')}}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'PCOrderSteps',
  components: {},
  data() {
    return {};
  },
  computed: {
    // 判断是否是PC端
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    })
  },
  methods: {}
};
</script>

<style scoped lang="less">
.pc_order-steps {
  height: 88px;
  display: flex;
  justify-content: center;
  .step-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    img {
      width: 36px;
      height: 36px;
      margin-bottom: 8px;
    }
  }
  .line {
    width: 120px;
    border-top: 1px dashed #8f949d;
    margin-top: 30px;
  }
}
</style>
